var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.globals.getIsLoggedIn())?_c('div',{staticClass:"vx-guest-create-account"},[_c('p',{staticClass:"text mb-xs-4"},[_vm._v(_vm._s(_vm.i18n.text))]),_vm._v(" "),_c('button',{staticClass:"btn btn-tertiary btn-small-text",on:{"click":function($event){return _vm.globals.navigateToUrl('register')}}},[_vm._v(_vm._s(_vm.i18n.button))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f239daae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/checkout/vx-guest-create-account/vx-guest-create-account.html
// module id = null
// module chunks = 